import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';

import '../css/app.pcss';

import Prism from 'prismjs';

// Use Prism highlighting
Prism.highlightAll();

// Add JS Loaded class to the body
document.documentElement.classList.add('js-loaded');

// App main
const main = async () => {
  await import('./_components.js');
  await import('./_sections.js');
  await import('./_vendors.js');
};

// Execute async function
main().then(() => {});
